module.exports = __webpack_public_path__ + "img/MOTUL.86fb8a9b.png";